export default __webpack_public_path__ + "static/media/american.76876fbc.svg";